import { QuestionBase } from './question-base';

/**@author Lupita Llamas
 * Model for the simple textbox
 */
export class TextboxQuestion extends QuestionBase<string> {
  controlType = 'textbox';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}



// WEBPACK FOOTER //
// ./src/app/models/question-textbox.ts